export default {
  startsWith: $localize`:@@starts_with:Starts with`,
  contains: $localize`:@@contains:Contains`,
  notContains: $localize`:@@doesnt_contains:Doesn\'t Contain`,
  endsWith: $localize`:@@ends_with:Ends with`,
  equals: $localize`:@@equals:Equals`,
  notEquals: $localize`:@@not_equals:Not Equals`,
  noFilter: $localize`:@@no_filter:No Filter`,
  lt: $localize`:@@less_than:Less Than`,
  lte: $localize`:@@less_than_or_equal_to:Less Than or equal to`,
  gt: $localize`:@@more_than:More Than`,
  gte: $localize`:@@more_than:More Than or equal to`,
  is: $localize`:@@is:Is`,
  isNot: $localize`:@@is_not:Is not`,
  before: $localize`:@@before:Before`,
  after: $localize`:@@after:After`,

  dateIs: $localize`:@@date_is:Date is`,
  dateIsNot: $localize`:@@date_is_not:Date is not`,
  dateBefore: $localize`:@@date_is_before:Date is before`,
  dateAfter: $localize`:@@date_is_after:Date is after`,
  clear: $localize`:@@clear:Clear`,
  apply: $localize`:@@apply:Apply`,
  matchAll: $localize`:@@match_all:Match All`,
  matchAny: $localize`:@@match_any:Match Any`,
  addRule: $localize`:@@add_rule:Add Rule`,
  removeRule: $localize`:@@remove_rule:Remove Rule`,
  accept: $localize`:@@yes:Yes`,
  reject: $localize`:@@no:No`,
  choose: $localize`:@@choose:Choose`,
  upload: $localize`:@@upload:Upload`,
  cancel: $localize`:@@cancel:Cancel`,
  dayNames: [
    $localize`:@@sunday:Sunday`,
    $localize`:@@monday:Monday`,
    $localize`:@@tueday:Tuesday`,
    $localize`:@@wednesday:Wednesday`,
    $localize`:@@thursday:Thursday`,
    $localize`:@@friday:Friday`,
    $localize`:@@saturday:Saturday`,
  ],
  dayNamesShort: [
    $localize`:@@sun:Sun`,
    $localize`:@@mon:Mon`,
    $localize`:@@tue:Tue`,
    $localize`:@@wed:Wed`,
    $localize`:@@thu:Thu`,
    $localize`:@@fri:Fri`,
    $localize`:@@sat:Sat`,
  ],
  dayNamesMin: [
    $localize`:@@su:Su`,
    $localize`:@@mo:Mo`,
    $localize`:@@tu:Tu`,
    $localize`:@@we:We`,
    $localize`:@@th:Th`,
    $localize`:@@fr:Fr`,
    $localize`:@@sa:Sa`,
  ],
  monthNames: [
    $localize`:@@january:January`,
    $localize`:@@february:February`,
    $localize`:@@march:March`,
    $localize`:@@april:April`,
    $localize`:@@may:May`,
    $localize`:@@june:June`,
    $localize`:@@july:July`,
    $localize`:@@august:August`,
    $localize`:@@saptember:September`,
    $localize`:@@october:October`,
    $localize`:@@november:November`,
    $localize`:@@december:December`,
  ],
  monthNamesShort: [
    $localize`:@@jan:Jan`,
    $localize`:@@feb:Feb`,
    $localize`:@@mar:Mar`,
    $localize`:@@apr:Apr`,
    $localize`:@@may:May`,
    $localize`:@@jun:Jun`,
    $localize`:@@jul:Jul`,
    $localize`:@@aug:Aug`,
    $localize`:@@sep:Sep`,
    $localize`:@@oct:Oct`,
    $localize`:@@nov:Nov`,
    $localize`:@@dec:Dec`,
  ],
  dateFormat: 'mm/dd/yy',
  firstDayOfWeek: 0,
  today: $localize`:@@today:Today`,
  weekHeader: $localize`:@@heak_header:Wk`,
  weak: $localize`:@@weak:Weak`,
  medium: $localize`:@@medium:Medium`,
  strong: $localize`:@@strong:Strong`,
  passwordPrompt: $localize`:@@enter_a_password:Enter a password`,
  emptyMessage: $localize`:@@empty_message:No results found`,
  emptyFilterMessage: $localize`:@@empty_filter_message:No results found`,
};
